var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"word-break py-5 mx-3",attrs:{"rounded":"0","flat":""}},[_c('h2',[_vm._v("Your PIN has been updated!")]),_c('span',{staticClass:"grey--text mt-2"},[_vm._v(" Your card is ready for use. ")]),_c('Robin',{staticClass:"d-flex justify-center",attrs:{"showText":false,"width":140,"height":140,"animation":"train","loop":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }